import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import videoProvider from '@/components/video-providers/index.vue'
import lessonSidebar from '../../components/lesson-sidebar/index.vue'
import hypercomments from '@/components/features/comments/index.vue'
import cackleWidgeComments from '@/components/features/cackle-widge-comments/index.vue'
import {seo} from '@/mixins/seo'
import {camelCase, throttle} from "lodash";

export default {
    name: 'course-material-detail',
    mixins: [seo],
    data() {
        return {
            comments: '',
            activeClass: false
        }
    },
    directives: {
        onClickaway: onClickaway,
    },
    components: {
        videoProvider,
        lessonSidebar,
        hypercomments,
        cackleWidgeComments,
    },
    computed: {
        ...mapGetters({
            currentItem: 'coursesStreams/currentItem',
            isLoading: 'coursesStreams/isCurrentItemLoading',
        }),
        getIdWidget() {
            if (!this.currentItem || !this.currentItem.comments.includes('widget_id:')) return '';
            const t = this.currentItem.comments;
            return this.getIdForWidget(t, 'widget_id:')
        },
        getIdCackleWidget() {
            if (!this.currentItem || this.currentItem.comments.includes('widget_id:')) return '';
            const t = this.currentItem.comments;
            return +this.getIdForWidget(t, 'id:')
        }
    },
    watch: {
        currentItem() {
            if (this.currentItem) {
                this.comments = this.currentItem.comments;
                this.setPlaysinline();
            }
        }
    },
    mounted() {
        if (this.currentItem) {
            this.comments = this.currentItem.comments;
            this.setPlaysinline();
        }

        this.$nextTick(() => {
            if (window.innerWidth < 600) {
                window.addEventListener('scroll', throttle(this.handleScroll, 15), true);
            }
        })
    },
    created() {
        this.fetchContent(this.$route.params).then(() => {
            if (this.currentItem) {
                Object.assign(this.seo, this.currentItem.seo.data)
            }
            this.seo.title = this.$t(camelCase(this.$route.name))
            this.$emit('updateHead')
        })
    },
    methods: {
        ...mapActions({
            fetchContent: 'coursesStreams/FETCH_STREAMS_ITEM'
        }),
        ...mapMutations({
            setCurrentItem: 'coursesStreams/STREAMS_SET_ITEM'
        }),
        handleScroll() {
            var el = document.getElementsByTagName("iframe")[0];
            this.activeClass = window.scrollY > el.offsetHeight - 200;
        },
        setPlaysinline() {
            this.$nextTick(() => {
                var el = document.getElementsByTagName("iframe")[0];
                el.setAttribute("playsinline", 1);
            })
        },
        getIdForWidget(currentItem, str) {
            const startIndex = currentItem.indexOf(str);
            const endIndex = currentItem.indexOf('});');
            const length = (endIndex - startIndex);
            let result = currentItem.substr(startIndex, length);
            return result.replace(str, '').replace(/"/g, '')
        }
    },
    destroyed() {
        this.setCurrentItem(null);
        window.removeEventListener('scroll', this.handleScroll);
    }
}
